/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { EditorType } from '@ckeditor/ckeditor5-metadata';

import { getPluginsToSelect } from '../getPluginsToSelect/getPluginsToSelect';
import { type Capability, capabilities } from '../../constants/capabilities';
import { type Preset, presets } from '../../constants/presets';

export type PresetView = Omit<Preset, 'features'> & {
	plugins: Array<string>;
};

const featureNames = ( capabilities as ReadonlyArray<Capability> ).flatMap( capability => capability.features );

export function getPresets(): Array<PresetView> {
	return presets.map( item => {
		return {
			editorType: item.editorType,
			id: item.id,
			editorContent: item.editorContent,
			name: item.name,
			plugins: getPluginsForFeatures( { features: item.features, editorType: item.editorType } ),
			description: item.description,
			toolbarOptions: item.toolbarOptions
		};
	} );
}

function getPluginsForFeatures( { features, editorType }: { features: ReadonlyArray<string>; editorType: EditorType } ) {
	const featurePlugins = features.flatMap( singleFeature => {
		const {
			plugins,
			isSinglePluginChoice,
			defaultPlugin
		} = featureNames.find( feature => feature.name === singleFeature )!;

		if ( isSinglePluginChoice ) {
			return defaultPlugin!;
		}

		return plugins;
	} );

	return getPluginsToSelect( [], featurePlugins, editorType );
}
